import { useForm } from "react-hook-form";
import GrayButton from "../../../../components/UI/buttonUI/GrayButton";
import DownloadTemplate from "../../../../components/common/DownloadTemplate";
import {
  UPLOAD_STATION_BULK,
  SITE_DOWNLOAD_TEMPLATE,
} from "../../apiEndpoints";
import SheetErrors from "../../../../components/common/SheetErrors";
import UploadFileInput from "../../../../components/UI/PageInput/UploadFileInput";
import PrimaryButton from "../../../../components/UI/buttonUI/PrimaryButton";
import BulkSIteSheetDialog from "./BulkSIteSheetDialog";
import useUploadSheet from "../../../../CustomHooks/useAxios/useUploadSheet";
import ErrorDisplay from "../../../../components/UI/ErrorDisplay";
import { Download } from "lucide-react";

const AddBulkSite = () => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      sheet: undefined,
    },
  });
  const {
    executePost,
    loading,
    isSucceed,
    formError,
    formErrMsg,
    responseData,
    setFormError,
    isErrorSheetList,
    setErrorSheetList,
  } = useUploadSheet();
  const sheet = watch("sheet");

  const onSubmit = async (data) => {
    // send data into form data
    const formData = new FormData();
    formData.append("sheet", data.sheet[0]);
    //API calling
    executePost(formData, UPLOAD_STATION_BULK, reset);
  };

  return (
    <>
      {formError && (
        <ErrorDisplay
          message={formErrMsg}
          closeAction={() => setFormError(false)}
        />
      )}
      <div className="flex justify-between">
        <p className="text-dg2">
          {sheet && sheet[0]?.name ? "Uploaded" : "Upload"} File
        </p>
        <DownloadTemplate
          apiEndPoint={SITE_DOWNLOAD_TEMPLATE}
          downloadFileName="station_bulk_upload"
        />
      </div>
      <form onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}>
        <UploadFileInput
          name="sheet"
          placeholder=".xlsx"
          accept=".xlsx, file/xlsx"
          register={{
            ...register("sheet", {
              required: "Please choose a file",
            }),
          }}
          setValue={setValue}
          multiple={true}
          error={errors.sheet}
          uploadedFile={sheet}
          removeUploadedFile={() => setValue("sheet", "")}
        />
        <div className="sheet-upload-btn-wrap">
            <PrimaryButton
              btnText={!loading ? "Upload Sheet" : "Adding..."}
              loading={loading}
              Icon={Download}
              size={20}
            />
            <GrayButton btnText="Clear" width="w-40" onClick={() => reset()} />
        </div>
      </form>
      {isErrorSheetList && (
        <SheetErrors
          errorList={responseData.sheetError}
          closeAction={() => setErrorSheetList(false)}
        />
      )}
      {isSucceed && <BulkSIteSheetDialog viewDetails={responseData} />}
    </>
  );
};

export default AddBulkSite;
